import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface CustomPaperProps {
  title: string;
  css: boolean;
}
const InputLabelComp = ({ title, css = false }: CustomPaperProps) => {
  return (
    <Typography
      variant="body2" // You can adjust the typography variant
      component="label"
      htmlFor="custom-input"
      sx={{ marginBottom: css === true ? "-22px" : "", display: "block" }}
    >
      {title}
    </Typography>
  );
};

export default InputLabelComp;
